import { SafeUrl } from "@angular/platform-browser";

export class SearchEmployeeDepartmentResultDto {
    ID: number;
    Code: string;
    DisplayName: string;
   }

   
export class EmployeeDepartmentSearchDto {
    SearchKey: string;
    InstanceId: number;
   
}